import { LINK_EXPIRIES, LINK_EXPIRY_SECONDS, type LinkExpiry } from '../../shared/api';

export interface ExpirySelectProps {
  value: LinkExpiry;
  onChange: (expiry: LinkExpiry) => void;
  disabled?: boolean;
  /** Optional id so callers can associate an external <label>. */
  id?: string;
}

/** Human-readable labels for the server-bounded expiry choices (spec §3). */
const LINK_EXPIRY_LABELS: Record<LinkExpiry, string> = {
  '1h': '1 hour',
  '24h': '24 hours',
  '7d': '7 days',
};

/**
 * Expiry selector for link issuance (spec §8 src/components/ expiry selector).
 * Constrained to {@link LINK_EXPIRIES} — arbitrary client-supplied expirations
 * are rejected server-side with `expiry_out_of_bounds`, so this control
 * cannot produce one.
 */
export default function ExpirySelect({ value, onChange, disabled = false, id }: ExpirySelectProps) {
  return (
    <select
      id={id}
      className="expiry-select"
      value={value}
      disabled={disabled}
      onChange={(event) => {
        const next = event.target.value as LinkExpiry;
        if (LINK_EXPIRIES.includes(next)) onChange(next);
      }}
    >
      {LINK_EXPIRIES.map((expiry) => (
        <option key={expiry} value={expiry}>
          {LINK_EXPIRY_LABELS[expiry]} ({LINK_EXPIRY_SECONDS[expiry]}s)
        </option>
      ))}
    </select>
  );
}
